import * as actions from "./chat.actions";
import * as api from "./chat.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./chat.constants";
import * as hooks from "./chat.hooks";
import * as promises from "./chat.promises";
import reducer from "./chat.reducer";
import { saga } from "./chat.saga";
import * as selectors from "./chat.selectors";
export var REDUCER_KEY_CHATS = REDUCER_KEY;
export var chatModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
